const initialState = {
    refreshProjectTable:'',
    searchProjectValue:'',
};
export const actionTypes = {
    REFRESH_PROJECT_TABLE: "REFRESH_PROJECT_TABLE",
    SEARCH_PROJECT_TABLE:"SEARCH_PROJECT_TABLE",
};

export const actions = {
    refresh_project_table: function (data) {
        return {
            type: actionTypes.REFRESH_PROJECT_TABLE,
            data
        }
    },
    search_project_table: function (data) {
        return {
            type: actionTypes.SEARCH_PROJECT_TABLE,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.REFRESH_PROJECT_TABLE:{
            return {...state,refreshProjectTable:action.data}
        }
        case actionTypes.SEARCH_PROJECT_TABLE:{
            return {...state,searchProjectValue:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/projectReducer.js